import { useQuery } from "react-query";
import { useCallback, useMemo, useState } from "react";
import { queryKeys } from "queries";
import api from "api";

type OrderStatusType = "open" | "past";

interface IOrderQueryParams {
	page?: number;
	size?: number;
}

const useOrderQuery = (status?: OrderStatusType) => {
	const pageSize = 25;
	const [params, setParams] = useState<IOrderQueryParams>({ page: undefined, size: undefined });
	const [currPage, setCurrPage] = useState<number>(1);

	const queryParams = Object.assign({ page: currPage, size: 25 }, { ...(status != undefined ? { status } : {}) });
	const query = useQuery([queryKeys.ORDER, "all", queryParams, currPage], () => api.order.get(queryParams).then((res) => res.data));
	const data = query.data;

	const nextPage = useCallback(
		() =>
			setCurrPage((page) => {
				if (data?.total === undefined || pageSize * page >= data?.total) {
					return page;
				}

				return page + 1;
			}),
		[data]
	);

	const prevPage = useCallback(() => setCurrPage((page) => (page <= 1 ? page : page - 1)), []);

	const setFirstPage = useCallback(() => setCurrPage(1), []);

	const setLastPage = useCallback(() => setCurrPage((page) => (data?.total === undefined ? page : Math.ceil(data?.total / pageSize))), [data]);

	return { query, params, setParams, nextPage, prevPage, setCurrPage, currPage, setFirstPage, setLastPage };
};

export { useOrderQuery };
